import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchAllUserData = createAsyncThunk("fetchAllUserData", async (token) => {

  const getEmployee = CryptoJS.SHA256("/getEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  let url = `${env.backend_api_endpoint}/${getEmployee}?name=&roleValue=`

  const response = await fetch(
    url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  }
  );
  const resData = await response.json();

  const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  const decryptedJSON = JSON.parse(decrypted);

  return decryptedJSON;

});

const AllUserDataSlice = createSlice({
  name: "allUserData",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllUserData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllUserData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchAllUserData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default AllUserDataSlice.reducer;